import { ReactComponent as GamesIcon } from '../../../shared/assets/icons/menu-icons/games.svg';
import { RouteProps } from '../../../shared/models/route-props.model';
import { WebGameFormContainer } from '../../components/game-form-container/web-game-form-container';
import { WebGames } from '../../components/web-games';
import WebGamesPageLayout from '../../components/web-games-page-layout';

export const getWebGamesRoutes = (): RouteProps[] => [
  {
    path: 'game-center-management',
    title: 'Game Center',
    element: <WebGamesPageLayout />,
    menuIcon: <GamesIcon />,
    children: [
      {
        path: 'games',
        title: 'Game Center',
        element: <WebGames />,
      },
      {
        path: 'create',
        title: 'Create New Game',
        element: <WebGameFormContainer />,
        notVisibleInMenu: true,
      },
      {
        path: 'edit/:id',
        title: 'Create New Game',
        element: <WebGameFormContainer />,
        notVisibleInMenu: true,
      },
    ],
  },
];
